// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1DSoA","colBig":"styles_colBig__CKNEq","colSmall":"styles_colSmall__7U-Dc"};